import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, UntypedFormControl, Validator } from '@angular/forms';

@Directive({
    selector: '[ssEmailDomainValidator] [ngModel], [ngModel] [ssEmailDomainValidator], [formControlName][ssEmailDomainValidator],[formControl][ssEmailDomainValidator],[ssEmailDomainValidator][formControlName],[ssEmailDomainValidator][formControl] ',
    providers: [
        { provide: NG_VALIDATORS, useExisting: EmailDomainValidator, multi: true }
    ]
})
export class EmailDomainValidator implements Validator {
    @Input() emailDomainValidatorConfig: EmailDomainValidatorConfig;

    // Validates whether the domain that the user selected is allowed with the client's list of allowed domains (if any)
    validate(c: UntypedFormControl): { [key: string]: boolean } | null {
        if (!c.value)
            return null;

        const allowedDomains: string[] = this.emailDomainValidatorConfig.allowedEmailDomains;

        // In the case of no value being present for allowed domains, do not evaluate (anything is allowed in that scenario).
        if (allowedDomains.length > 0) {
            // Split on anything after the '@' (should be the domain)
            const emailDomain = c.value.split('@')[1];

            const isValid = allowedDomains.includes(emailDomain);
            if (isValid)
                return null;
            else
                return {
                    domain: true
                };
        }
        return null;
    }
}

// This is not nullable;
// We want this to blow up if the configuration isn't passed.
// Hence no check for the object above before trying to access it
class EmailDomainValidatorConfig {
    allowedEmailDomains: string[];
}
